export const POINT_FIELDS = [
  { place: 1, key: 'points_1', label: '1-е место' },
  { place: 2, key: 'points_2', label: '2-е место' },
  { place: 3, key: 'points_3', label: '3-е место' },
  { place: 4, key: 'points_4', label: '4-е место' },
  { place: 5, key: 'points_5', label: '5-е место' },
  { place: 6, key: 'points_6', label: '6-е место' },
  { place: 7, key: 'points_7', label: '7-е место' },
  { place: 8, key: 'points_8', label: '8-е место' },
]

export const getPoint = (record, place) => {
  const point = (record.rating_points || []).find((item) => Number(item.place) === place)
  return point ? point.points : undefined
}
